import React, { useState } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import Login from "./Components/Login";
import Register from "./Components/Register";
import Welcome from "./Components/Welcome";
import ForgotPassword from "./Components/ForgotPassword";
import ForgotPasswordVerify from "./Components/ForgotPasswordVerify";
import ChangePasswordConfirm from "./Components/ChangePasswordConfirm";

import { Container, SubContainer, Logo, AuthBackground } from "./authStyle";

import logo from "../../assets/newLogo.png";

export default function AuthMain() {
  const [height, setHeight] = useState(540);
  const [slideUp, setSlideUp] = useState(false);
  return (
    <Container>
      <AuthBackground />
      <SubContainer height={height} slideUp={slideUp}>
        <Logo src={logo} alt="logo" />
        <Router>
          <Switch>
            <Route
              exact
              path="/register"
              render={(props) => <Register {...props} setHeight={setHeight} />}
            />
            <Route
              exact
              path="/welcome"
              render={(props) => <Welcome {...props} setHeight={setHeight} />}
            />
            <Route exact path="/forgotPassword" component={ForgotPassword} />
            <Route
              exact
              path="/forgotPasswordVerify"
              render={(props) => (
                <ForgotPasswordVerify {...props} setHeight={setHeight} />
              )}
            />
            <Route
              exact
              path="/changePasswordConfirm"
              render={(props) => (
                <ChangePasswordConfirm {...props} setHeight={setHeight} />
              )}
            />
            <Route
              render={(props) => (
                <Login
                  {...props}
                  onSignIn={() => setSlideUp(true)}
                  setHeight={setHeight}
                />
              )}
            />
          </Switch>
        </Router>
      </SubContainer>
    </Container>
  );
}
